var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"titleToolbar"},[(!_vm.$route.subtitle)?_c('TemplateTitleToolbar'):_vm._e(),_vm._v(" "),(_vm.$route.subtitle)?_c('VideoTitleToolbar'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53ed7795","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/subtitle/titleToolbar/titleToolbar.vue
// module id = null
// module chunks = 